import {getEnv} from "./index";

export const FEATURES_INVESTORS = true
